import * as React from "react";

import { Doc } from "affinityUI/structures/doc";

import collectionProcessPage from "./assets/Collection process page.png";
import withdrawDeviceButton from "./assets/Withdraw device button.png";
import withdrawDeviceConfirmation from "./assets/Withdraw device confirmation.png";
export const WithdrawDeviceSection: React.FC = () => {
  return (
    <Doc.Section title="Withdraw Device">
      <p>
        When the patient finishes testing with Entia Liberty, the patients&apos; device will need to be withdrawn from
        the study. To do so, click the “withdraw device” within Device Details.
      </p>
      <Doc.Illustration src={withdrawDeviceButton} label="Withdraw device button" />
      <p>Click on the “withdraw device” link to open the Withdraw device page.</p>
      <Doc.Note>
        <strong>Please note:</strong> To be able to withdraw a device from the patient your user profile must have
        corresponding permissions. The link will not be visible if access to this functionality is not allowed for your
        user profile. If such situation occurs and you need access to this functionality, please contact the Entia
        support team.
      </Doc.Note>
      <Doc.Illustration src={collectionProcessPage} label="Collection process page" />
      <p>
        This page contains an explanation of the next steps which will happen when the device withdrawal process is
        triggered:
      </p>
      <ul>
        <li>The patient will be notified of device withdrawal</li>
        <li>The device will be collected by Entia within 7 days</li>
        <li>Results remain on the Entia Liberty Patient List</li>
      </ul>
      <p>After clicking on the “ Continue to Confirmation” button, the confirmation page will be opened.</p>
      <Doc.Illustration src={withdrawDeviceConfirmation} label="Withdraw device confirmation" />
      <p>
        Click the “Withdraw Device” button to open the Review Patient page. The information about the withdrawn device
        will be presented in the Device Details section on the Review Patient page.
      </p>
      <p>Clicking the “Cancel” button will open the Review Patient page without the device withdrawn.</p>
    </Doc.Section>
  );
};
